import { changePage } from './components/switch.js';
import { loginNav } from './components/login.js';
import { history } from './components/history.js';
import { scan } from './components/scan.js';
import { service } from './components/service.js';
import { param } from './components/param.js';

changePage();

loginNav();

history();

scan();

service();

param();

setTimeout(function () {
  document.querySelector('.loading').style.display = 'none';
}, 1000);
document.querySelector('.service__cross').addEventListener('click', (e) => {
  e.preventDefault();
  const descEl = document.querySelectorAll('.service__parts');

  descEl.forEach(part => {
    part.classList.remove('service__parts--hidde');
  });

  document.querySelector('.service__description').classList.add('service__parts--hidde');
});
